import { DealerNamePlaceholder } from '../DealerNamePlaceholder';
import { UNKNOWN_DEALER_LABEL } from '../../utils/templateOwnership';

interface Props {
  dealerId: string;
  dealerNames: ReadonlyMap<string, string>;
  isResolvingDealers?: boolean;
}

export function DealerLabel({ dealerId, dealerNames, isResolvingDealers = false }: Props) {
  const name = dealerNames.get(dealerId);
  if (name) return <span>{name}</span>;
  return isResolvingDealers ? <DealerNamePlaceholder /> : <span>{UNKNOWN_DEALER_LABEL}</span>;
}
